const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const toCurrency = (value: number): string =>
  currencyFormatter.format(value);
